import { useState, useEffect } from 'react';
import Dashboard from './Dashboard';
import Login from './Login';
import AdminPanel from './AdminPanel';
import './App.css';

const SESSION_KEY = "lynco_session";

function App() {
  const [session, setSession] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(SESSION_KEY);
      if (saved) setSession(JSON.parse(saved));
    } catch {
      localStorage.removeItem(SESSION_KEY);
    }
    setReady(true);
  }, []);

  function handleLogin(user) {
    localStorage.setItem(SESSION_KEY, JSON.stringify(user));
    setSession(user);
  }

  function handleLogout() {
    localStorage.removeItem(SESSION_KEY);
    setSession(null);
  }

  if (!ready) return null;

  if (!session) return <Login onLogin={handleLogin} />;

  if (session.role === "admin") return <AdminPanel admin={session} onLogout={handleLogout} />;

  return <Dashboard baseId={session.baseid} username={session.username} onLogout={handleLogout} />;
}

export default App;
